<script>

import Multiselect from 'vue-multiselect'
import { periodicTasksClockedScheduleMethods } from '@state/helpers'
import { required } from 'vuelidate/lib/validators'
import ClockedScheduleForm from "@components/scheduled-tasks/clocked-schedule/form";
import ClockedScheduleDelete from "@components/scheduled-tasks/clocked-schedule/delete";


export default {
  name: 'ClockedScheduleSelector',
  components: {Multiselect , ClockedScheduleForm, ClockedScheduleDelete},
  props: {
    value: {
      required: false,
      default: ()=>(''),
    },
  },
  data() {
    return {
      loading: false,
      showForm: false,
      showDelete: false,
      toUpdate: {},
      toDelete: {},
      periodicTasksClockedScheduleOptions: [],
      loadingPeriodicTasksClockedScheduleOptions: false,
      periodicTasksClockedScheduleOptionsMounted: true,
      periodicTasksClockedScheduleOptionsCache: []
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  mounted: function () {
    let context = this
    context.populatePeriodicTasksClockedScheduleOptions()
  },

  methods: {
    ...periodicTasksClockedScheduleMethods,

    populatePeriodicTasksClockedScheduleOptions(searchQuery){
      let context = this
      context.loadingPeriodicTasksClockedScheduleOptions = true
      let reqParams = context.$select_params(searchQuery)
      // reqParams = `${reqParams}${!reqParams ? '?' : '&'}customer=${context.form.customer}`
      const promise = context.fetchPeriodicTasksClockedSchedule(reqParams)
      return promise.then(data => {
          let listOptions = []
          data.results.forEach(opt => {
              listOptions.push({
                  'url': opt.url,
                  'name': opt.formatted_datetime
              })
          });
          context.periodicTasksClockedScheduleOptions = listOptions
          context.loadingPeriodicTasksClockedScheduleOptions = false
          context.periodicTasksClockedScheduleOptionsMounted = true
      }).catch(error => {
          context.$axios_error_noty(error, context)
          context.loadingPeriodicTasksClockedScheduleOptions = false
          context.periodicTasksClockedScheduleOptionsMounted = true
      })
    },

    asyncFindPeriodicTasksClockedSchedule: _.debounce(function (searchQuery) {
        this.populatePeriodicTasksClockedScheduleOptions(searchQuery)
    }, 600),

    labelOfPeriodicTasksClockedSchedule(opt){
      let context = this
      let optionFound = context.periodicTasksClockedScheduleOptions.find(x => x.url === opt)
      if (!optionFound){
          let cacheFound = context.periodicTasksClockedScheduleOptionsCache.find(x => x.url === opt)
          return  cacheFound ? cacheFound.name : context.periodicTasksClockedScheduleOptionsMounted ? `No encontrado en las opciones: ${opt}`: ''
      }else{
          if (context.inputVal === opt){
              if (!context.periodicTasksClockedScheduleOptionsCache.find(x => x.url === opt)){
                  context.periodicTasksClockedScheduleOptionsCache.push(optionFound)
              }
          } 
          return optionFound.name
      }
    },
    
  },
}
</script>

<template>
  <b-container class="p-0">
    <b-row v-if="loading">
      <b-col md="12">
        <div class="text-center">
          <b-spinner
            label="Spinning"
            style="color: #195db2; width: 4rem; height: 4rem"
          ></b-spinner>
        </div>
      </b-col>
    </b-row>
    <b-form-group v-else label="Seleccionar fecha programada">
      <b-row>
        <b-col md="9">
          <Multiselect
              id="clocked-schedule-select"
              v-model="inputVal"
              :multiple="false"
              :options="periodicTasksClockedScheduleOptions.map(x => x.url)" 
              :custom-label="opt => labelOfPeriodicTasksClockedSchedule(opt)"
              :loading="loadingPeriodicTasksClockedScheduleOptions"
              :internal-search="false"
              @search-change="asyncFindPeriodicTasksClockedSchedule">
          </Multiselect>
        </b-col>
        <b-col md="3" class="justify-content-center align-self-center">
          <b-button-group size="xs">
            <b-button
              variant="primary"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showForm=true; toUpdate={}}">
              <i class="fad fa-plus"></i>
            </b-button>  
            <b-button
              v-if="inputVal"
              variant="warning"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showForm=true; toUpdate={url:inputVal}}">
              <i class="fad fa-pen"></i>
            </b-button>    
            <!-- <b-button
              v-if="inputVal"
              variant="danger"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showDelete=true; toDelete={url:inputVal}}">
              <i class="fad fa-x"></i>
            </b-button> -->
          </b-button-group>
        </b-col>
      </b-row>
    </b-form-group>

    <ClockedScheduleForm 
      v-if="showForm"
      :instanceJson="toUpdate || {}"
      :oncomplete="(selectedObj)=>{
        showForm=false;
        toUpdate={};
        populatePeriodicTasksClockedScheduleOptions(); inputVal = selectedObj}"
      :oncancel="()=>{
        showForm=false;
        toUpdate={}}">
    </ClockedScheduleForm>

    <ClockedScheduleDelete 
      v-if="showDelete"
      :instanceJson="toDelete || {}"
      :oncomplete="(selectedObj)=>{
        showDelete=false;
        toDelete={};
        inputVal=null;
        populatePeriodicTasksClockedScheduleOptions()}"
      :oncancel="()=>{
        showDelete=false;
        toDelete={};
        populatePeriodicTasksClockedScheduleOptions()}">
    </ClockedScheduleDelete>

  </b-container>
</template>
<style lang="scss">
</style>